import { Routes, Route, Navigate } from 'react-router-dom';
import { ExpertDashboardLayout } from '../../layouts/ExpertDashboardLayout';
import ExpertDashboardHome from './ExpertDashboardHome';
import ExpertMessagesPage from './ExpertMessagesPage';

// 🟢 IMPORT YOUR DUMMY PAGES
import ExpertWalletCheckout from './ExpertWallet/ExpertWalletCheckout';
import ExpertOrdersPage from './expertOrder/ExpertOrdersPage';
import ExpertActivityLogsPage from './ExpertActivityLogsPage'; 

// 🟢 IMPORT THE NEW REVIEWS PAGE
import ExpertDashboardReviews from './ExpertDashboardReviews'; 

// 🟢 IMPORT THE NEW BLOG PAGE
import ExpertBlogPage from './ExpertBlogPage';

import ExpertKundli from './ExpertKundli';

// 🟢 IMPORT THE NEW SETTINGS PAGE
import { ExpertSettingsPage } from './ExpertSettingsPage'; 

// 🟢 IMPORT LIVE STREAM COMPONENTS
import { LiveStreamWrapper } from '../../components/liveStream/LiveStreamWrapper';
import { ExpertLiveStream } from '../../components/liveStream/ExpertLiveStream';

export default function ExpertWrapper() {
  return (
    <Routes>
      <Route element={<ExpertDashboardLayout />}>
        {/* Default route */}
        <Route index element={<Navigate to="/expert-dashboard/dashboard" replace />} />
        
        {/* Existing Pages */}
        <Route path="dashboard" element={<ExpertDashboardHome />} />
        <Route path="messages" element={<ExpertMessagesPage />} />
        
        {/* Wallet & Activity Pages */}
        <Route path="wallet" element={<ExpertWalletCheckout />} />
        <Route path="orders" element={<ExpertOrdersPage />} />
        <Route path="activity-logs" element={<ExpertActivityLogsPage />} /> 
        
        {/* 🟢 NEW REVIEWS PAGE */}
        <Route path="reviews" element={<ExpertDashboardReviews />} />

        {/* 🟢 NEW BLOG PAGE */}
        <Route path="blog" element={<ExpertBlogPage />} />
        
        {/* 🟢 KUNDLI PAGE */}
        <Route path="kundli" element={<ExpertKundli/>}/>

        {/* 🟢 NEW SETTINGS PAGE */}
        <Route path="settings" element={<ExpertSettingsPage />} />

        {/* 🔴 EXPERT LIVE STREAM ROUTE */}
        <Route 
          path="live" 
          element={
            <LiveStreamWrapper>
              <ExpertLiveStream />
            </LiveStreamWrapper>
          } 
        />
        
        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/expert-dashboard/dashboard" replace />} />
      </Route>
    </Routes>
  );
}